(() => {
  if (window.cardSwatchesInitialized) return;
  window.cardSwatchesInitialized = true;

  const selectSwatch = (swatch) => {
    const swatchGroup = swatch.closest('.card-swatches');
    const card = swatch.closest('.card-wrapper');
    if (!swatchGroup || !card) return;

    const mediaEl = card.querySelector('.card__media .media');
    const mainImage = mediaEl?.querySelector('img:first-child');
    const hoverImage = mediaEl?.querySelector('img + img');
    const productLinks = card.querySelectorAll(
      '.card__image-link, a[id^="CardLink-"], a[id^="StandardCardNoMediaLink-"]'
    );
    const imgUrl = swatch.dataset.imageUrl;
    const srcset = swatch.dataset.srcset;
    const variantUrl = swatch.dataset.variantUrl;

    if (mainImage && imgUrl) {
      mainImage.src = imgUrl;
      if (srcset) mainImage.srcset = srcset;
    }
    if (hoverImage && imgUrl) {
      hoverImage.src = imgUrl;
      if (srcset) hoverImage.srcset = srcset;
    }
    if (variantUrl) {
      productLinks.forEach((link) => {
        link.href = variantUrl;
      });
    }

    swatchGroup.querySelectorAll('.card-swatch').forEach((item) => item.classList.remove('is-active'));
    swatch.classList.add('is-active');
  };

  document.addEventListener('mouseover', (event) => {
    const swatch = event.target.closest('.card-swatch');
    if (swatch) selectSwatch(swatch);
  });

  document.addEventListener('focusin', (event) => {
    const swatch = event.target.closest('.card-swatch');
    if (swatch) selectSwatch(swatch);
  });

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('.card-swatch');
    if (swatch) selectSwatch(swatch);
  });
})();
